import React from "react";
import { Field } from "formik";

export default function TextInput({ className, name, placeholder, ...props }) {
    return (
        <Field
            className={className}
            name={name}
            type="text"
            placeholder={placeholder}
            {...props}
        />
    );
}
